import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import OPComponent from '../op_component';
import { COLOR, PARTICIPANT_COLORS, FONT_SIZE, FONT } from '../../../constants/styles';

const md5 = require('md5');

export default class ProfileImage extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  initials(nameStr) {
    return nameStr
      .split(' ')
      .slice(0, 3)
      .map(namePart => namePart.charAt(0).toUpperCase())
      .join('');
  }

  color(nameStr) {
    let nameHash = md5(nameStr);
    let dec = parseInt(nameHash.charAt(0), 16);
    let colorIndex = dec % PARTICIPANT_COLORS.length;
    return PARTICIPANT_COLORS[colorIndex];
  }

  render() {
    let { nameStr, containerStyles } = this.props;
    if (!nameStr) {
      return null;
    }

    let textStyle = null;
    if (containerStyles.width && containerStyles.width <= 40) {
      textStyle = { fontSize: FONT_SIZE.regular };
    }
    if (containerStyles.width && containerStyles.width <= 35) {
      textStyle = { fontSize: FONT_SIZE.small };
    }

    return (
      <View style={[styles.container, containerStyles, { backgroundColor: this.color(nameStr) }]}>
        <Text style={[styles.initialsText, textStyle]}>{this.initials(nameStr)}</Text>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: COLOR.success,
  },
  initialsText: {
    ...FONT.regular,
    fontSize: FONT_SIZE.large,
    color: COLOR.textReversed,
  },
});
